export default "__VITE_ASSET__C1BU2qLQ__"